<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Top Star</h1>
<p class="BOD2">A single star or several stars overlapping will add a dash of magic to whatever they touch.</p>
<p class="IMAGE"><img alt="" src="images/C1-13.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-14.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-7.vue?3113c302